// extracted by mini-css-extract-plugin
module.exports = {"Title":"FranchizeTitle_Title__2lo0f"};